import { IIntegrationStore } from './index'

export default {
  settings: null,
  saving: false,
} as IIntegrationStore
